module.exports = __webpack_public_path__ + "application/templates/terms-conditions/terms-conditions.template.html";